import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import CanonicalTag from '@/components/CanonicalTag';
import grannyFlatVsADUImage from '@/assets/granny-flat-vs-adu.jpg';

const IsGrannyFlatSameAsADUCalifornia = () => {
  const [showCalendly, setShowCalendly] = useState(false);
  const openCalendlyModal = () => setShowCalendly(true);
  const closeCalendlyModal = () => setShowCalendly(false);

  return (
    <>
      <CanonicalTag url="https://www.udaadu.com/granny-flat-vs-adu-california" />
      
      {/* Calendly Modal */}
      {showCalendly && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div className="relative bg-white rounded-lg w-full max-w-4xl h-full max-h-[90vh]">
            <button 
              onClick={closeCalendlyModal} 
              className="absolute top-4 right-4 z-10 p-2 bg-white rounded-full shadow-md hover:bg-gray-100 transition-colors"
            >
              ✕
            </button>
            <iframe 
              src="https://calendly.com/udaadu?embed=true&hide_gdpr_banner=1" 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              title="Schedule a meeting"
            />
          </div>
        </div>
      )}
      
      <div className="min-h-screen bg-background">
        <Navigation />
        
        <main className="container mx-auto px-4 py-8">
          {/* Hero Section */}
          <div className="mb-12">
            <img 
              src={grannyFlatVsADUImage} 
              alt="Granny flat vs ADU comparison" 
              className="w-full h-64 md:h-96 object-cover rounded-lg mb-8"
            />
            
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#E4683B' }}>
              Is Granny Flat the Same as an ADU?
            </h1>
            
            <p className="text-lg md:text-xl text-white leading-relaxed mb-8">
              Understand the similarities and differences between granny flats and ADUs in California, including legal definitions and usage variations.
            </p>
          </div>

          {/* Content Sections */}
          <div className="space-y-12">
            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Terminology and Legal Definitions
              </h2>
              <p className="text-white leading-relaxed mb-6">
                "Granny flat" is a colloquial term for what California law officially defines as an Accessory Dwelling Unit (ADU). Both terms refer to the same legal housing type: a self-contained residential unit with independent living facilities located on the same property as a primary dwelling.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Historical vs. Modern Usage
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Historically, "granny flat" implied housing for elderly family members, while modern ADU legislation encompasses broader uses including rental income, home offices, and housing for various family situations. Today's ADUs serve multiple purposes beyond elder care, reflecting California's diverse housing needs.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Regulatory and Permitting Similarities
              </h2>
              <p className="text-white leading-relaxed mb-6">
                Whether called a granny flat or ADU, both follow identical California permitting processes, building codes, and zoning requirements. The same size limitations, setback rules, and utility requirements apply regardless of terminology, as they represent the same legal housing classification.
              </p>
            </section>

            <section>
              <h2 className="text-3xl font-bold mb-6" style={{ color: '#E4683B' }}>
                Frequently Asked Questions
              </h2>
              <div className="text-white leading-relaxed space-y-6">
                <div>
                  <p className="font-semibold mb-2">Q: Are there legal differences between granny flats and ADUs?</p>
                  <p>A: No, they are the same under California law - both are officially classified as ADUs.</p>
                </div>
                
                <div>
                  <p className="font-semibold mb-2">Q: Can granny flats be used for rental income like ADUs?</p>
                  <p>A: Yes, granny flats and ADUs have identical rental and usage permissions under state law.</p>
                </div>
              </div>
            </section>
          </div>

          {/* Call-to-Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mt-12">
            <Button 
              onClick={openCalendlyModal}
              className="bg-primary text-primary-foreground hover:bg-primary/90 px-8 py-3 text-lg"
            >
              Book & Schedule
            </Button>
            <Button 
              asChild
              variant="outline"
              className="border-primary text-primary hover:bg-primary hover:text-primary-foreground px-8 py-3 text-lg"
            >
              <Link to="/landing">Learn More</Link>
            </Button>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default IsGrannyFlatSameAsADUCalifornia;